import { useEffect, useState } from "react";
import styled from "styled-components"

import { withGoogleMap, GoogleMap, Polygon } from "react-google-maps"
import { 
    BooneCounty,
    BrownCounty, 
    ButlerCounty, 
    CampbellCounty,
    ClermontCounty, 
    ClintonCounty,
    HamiltonCounty, 
    HighlandCounty,
    KentonCounty, 
    WarrenCounty 
} from "../CountyCoordinates/Coordinates";

const countyPolygonOptions = {
    fillColor: '#2b6cd4',
    fillOpacity: 0.4,
    strokeColor: 'black',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false
};

const counties = [
    WarrenCounty,
    KentonCounty,
    BrownCounty,
    ClermontCounty,
    ClintonCounty,
    BooneCounty,
    ButlerCounty,
    HamiltonCounty,
    HighlandCounty,
    CampbellCounty
];

const Map = () =>{

    const defaultCenter = {lat: 39.29, lng: -83.98}
    const [zoom, setZoom] = useState(0);

    useEffect(() =>{
        const setCustomZoom = () =>{
            if(window.innerWidth <= 1300){
                setZoom(7)
            }else{setZoom(8)}
        }
        setCustomZoom();

        window.addEventListener('resize', setCustomZoom);
        return () => {
            window.removeEventListener('resize', setCustomZoom);
        };
    }, [])

    const CountyMap = withGoogleMap(() => (
        <CoverageCountyMap 
            center={defaultCenter}
            defaultZoom={zoom}
        >
            {counties.map((paths, index) => (
                <Polygon
                    key={index}
                    paths={paths}
                    options={countyPolygonOptions}
                />
            ))}
        </CoverageCountyMap>
    ));

    return( 
        <MapDiv onContextMenu={(e)=>e.preventDefault()}>
            <CountyMap
                containerElement={ <CoverageContainerElement/> }
                mapElement={ <CoverageMapElement />}
                draggable={false}
            />
        </MapDiv>
    )
}

const CoverageCountyMap = styled(GoogleMap)`
    
`

const CoverageContainerElement = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
`

const CoverageMapElement = styled.div`
    height: 95%;
    width: 95%;
    margin: auto;
`

const MapDiv = styled.div`
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.3);
    border: 1px solid white;
    border-radius: 5px;
    box-shadow: 5px 5px 5px rgb(0 0 0 / 0.2);
`

export default Map
